import LandingHeader from "@/components/landing/LandingHeader";
import HeroSection from "@/components/landing/HeroSection";
import ContentSections from "@/components/landing/ContentSections";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";

const LandingPage = () => (
  <div className="app" data-testid="landing-page">
    <LandingHeader />
    <HeroSection />
    <ContentSections />
    <ContactSection />
    <Footer />
  </div>
);

export default LandingPage;